import { trackEvent } from "@intercom/messenger-js-sdk";
import { produce } from "immer";
import { useCuepointsStore } from "../../../animator/useCuepointsStore";
import { useHighlightsStore } from "../../../animator/useHighlightsStore";
import { postToIframe } from "../../../animator/utils";
import { AnalyticsEvents } from "types/analytics";
import {
  parseScript,
  serializeScript,
  removeAnchorsByTag,
} from "pages/media/helpers/scriptAnchors";

export const useRemoveAll = () => {
  const { setCurrentCuepoint, deleteAllCuepoints } = useCuepointsStore();
  const {
    setCurrentHighlight,
    deleteAllHighlights,
    highlightedStoryboard,
    setHighlightedStoryboard,
    deleteAllSectionHighlight,
  } = useHighlightsStore();

  const removeAll = (projectId: string) => {
    deleteAllCuepoints();
    deleteAllHighlights();
    deleteAllSectionHighlight();
    setCurrentHighlight(undefined);
    setCurrentCuepoint(undefined);

    if (highlightedStoryboard) {
      setHighlightedStoryboard(
        produce(highlightedStoryboard, (draft) => {
          for (const section of draft.sections) {
            const script = section.script;
            if (!script) continue;
            script.content = serializeScript(
              removeAnchorsByTag(parseScript(script.content ?? ""), "HL")
            );
          }
        })
      );
    }
    trackEvent(AnalyticsEvents.DocumentAnimationDeleteAll, {
      project_id: projectId,
    });
    postToIframe({
      type: "remove-all-highlights",
    });
  };

  return removeAll;
};
